// extracted by mini-css-extract-plugin
export default {"container":"PauseView_container__3GBiP","background":"PauseView_background__yLXsB","blur":"PauseView_blur__DlYLF","buttonsContainer":"PauseView_buttonsContainer__-mJHc"};